export var AlignMap;
(function (AlignMap) {
    AlignMap["auto"] = "auto";
    AlignMap["baseline"] = "baseline";
    AlignMap["center"] = "center";
    AlignMap["end"] = "flex-end";
    AlignMap["start"] = "flex-start";
    AlignMap["stretch"] = "stretch";
})(AlignMap || (AlignMap = {}));
export const align = [
    'auto',
    'baseline',
    'center',
    'end',
    'start',
    'stretch',
];
export const grow = ['inherit', 'unset', 'initial'];
export const shrink = ['inherit', 'unset', 'initial'];
//# sourceMappingURL=LayoutItem.types.mjs.mjs.map